// frontend/src/api/CNASTDRBSFileApi.js (ejemplo)

import api from "./api";

// Obtener todos los archivos
export const fetchCNASTDRBSFiles = async () => {
  try {
    const response = await api.get("/cna-std-rbs-files/");
    return response.data;
  } catch (error) {
    console.error("Error fetching CNA STD RBS file records:", error);
    throw error;
  }
};

// Obtener un archivo por ID
export const fetchCNASTDRBSFileById = async (id) => {
  try {
    const response = await api.get(`/cna-std-rbs-files/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching CNA STD RBS file with ID ${id}:`, error);
    throw error;
  }
};

// Obtener archivos de propuesta
export const listCNASTDRBSFilesByProposal = async (proposalId) => {
  const response = await api.get(`/cna-std-rbs-files/proposal/${proposalId}/`);
  return response.data;
};

// Buscar archivos por nombre (contiene)
export const searchCNASTDRBSFiles = async (query) => {
  try {
    const response = await api.get(`/cna-std-rbs-files/?search=${encodeURIComponent(query)}`);
    return response.data;
  } catch (error) {
    console.error(`Error searching CNA STD RBS files with query "${query}":`, error);
    throw error;
  }
};

// Crear un nuevo archivo
export const createCNASTDRBSFile = async (data) => {
  try {
    const response = await api.post("/cna-std-rbs-files/", data);
    return response.data;
  } catch (error) {
    console.error("Error creating CNA STD RBS file:", error);
    throw error;
  }
};

// Actualizar un archivo (solo si es del usuario)
export const updateCNASTDRBSFile = async (id, data) => {
  try {
    const response = await api.put(`/cna-std-rbs-files/${id}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error updating CNA STD RBS file with ID ${id}:`, error);
    throw error;
  }
};

// Eliminar un archivo (solo si es del usuario)
export const softDeleteCNASTDRBSFile = async (id) => {
  try {
    const response = await api.delete(`/cna-std-rbs-files/${id}/`);
    return response.data;
  } catch (error) {
    console.error("Error soft-deleting CNA STD RBS files:", error);
    throw error;
  }
};

// Exportar archivos por ID
export const exportCNASTDRBSFilesById = async (idsArray) => {
  try {
    const idsParam = idsArray.join(",");
    const response = await api.get(`/cna-std-rbs-files/export/?ids=${idsParam}`, {
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting CNA STD RBS file by ID:", error);
    throw error;
  }
};

// Filtros generales
export const filterCNASTDRBSFiles = async (params) => {
  try {
    const query = new URLSearchParams(params).toString();
    const response = await api.get(`/cna-std-rbs-files/?${query}`);
    return response.data;
  } catch (error) {
    console.error("Error filtering CNA STD RBS files:", error);
    throw error;
  }
};
